import * as React from "react";
import { useState } from "react";
import { imageBaseUrl } from "../utils/variables";
import "./styles.scss";
var Header = function (props) {
    var _a = useState(false), isOpen = _a[0], updateIsOpen = _a[1];
    var switchCardState = function (flag, event) {
        if (flag && event) {
            event.stopPropagation();
        }
        updateIsOpen(flag);
    };
    var logoutHandler = function () {
        switchCardState(false);
        props.logout();
    };
    var handelBlur = function () {
        if (isOpen) {
            updateIsOpen(false);
        }
    };
    return (React.createElement("div", { className: "header-container" },
        React.createElement("div", { className: "logo-container" },
            React.createElement("img", { className: "left-logo", src: props.productLogoURL, alt: "shubhlife-logo" })),
        props.login && (React.createElement("div", { tabIndex: -1, className: "profile-container ".concat(isOpen ? "open-profile-details" : ""), onClick: function (event) { return switchCardState(!isOpen, event); }, onBlur: handelBlur },
            React.createElement("div", { className: "profile-img" },
                React.createElement("img", { src: props.login && props.login["imageUrl"], alt: "profile-name" })),
            React.createElement("div", null,
                React.createElement("img", { className: "profile-arrow", src: "".concat(imageBaseUrl, "/images/arrow.svg"), alt: "profile-arrow" })),
            React.createElement("div", { className: "profile-details", onClick: function (e) { return e.stopPropagation(); } },
                React.createElement("div", { className: "profile-details-container" },
                    React.createElement("div", { className: "profile-img" },
                        React.createElement("img", { src: props.login && props.login["imageUrl"], alt: "user-logo" })),
                    React.createElement("div", { className: "profile-username", title: props.login && props.login["name"] }, props.login && props.login["name"]),
                    React.createElement("div", { className: "profile-mail", title: props.login && props.login["email"] }, props.login && props.login["email"])),
                React.createElement("div", { className: "profile-logout", onClick: logoutHandler }, "Logout"))))));
};
Header.defaultProps = {
    productLogoURL: "".concat(imageBaseUrl, "/img/logo/logo-row.svg"),
};
export default Header;
//# sourceMappingURL=index.js.map